import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import styles from './currensy-sign.scss';
import { CURRENCIES, DEFAULT_CURRENCY } from '@wix/wix-vod-constants/common';
export class CurrencySign extends React.Component {
  render() {
    const {
      currency
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: styles.currencySign,
      "data-hook": "currency-symbol"
    }, CURRENCIES[currency].symbol);
  }
}
_defineProperty(CurrencySign, "defaultProps", {
  currency: DEFAULT_CURRENCY
});
//# sourceMappingURL=currency-sign.js.map